/*jslint regexp: true */

/**
 * A reusable dropdown plugin for jQuery
 * Allows the user to choose from a list of options or type a custom option
 */
(function ($) {
   "use strict";

   function getList (jSelectBox) {
      var aList = [];

      jSelectBox.find('option').each(function(i, elOption) {
         var jOption = $(elOption),
            strValue = jOption.attr('value'),
            strText = jOption.text(),
            strDisplay = jOption.attr('selectedDisplay');

         aList.push([
            strValue,
            strText,
            strDisplay
         ]);
      });

      return aList;
   }

   var methods = {
         /**
          * Create the dropdown
          * Required options:
          *   baseName - The base name from which to create the inputs. Ex: "bedrooms" would create "bedroomsFrom" and "bedroomsTo"
          * Optional options: 
          *   dropdownClass - An additional class for the dropdown
          *   selectBoxClass - An additional class for the select box
          *   formatter - A function that accepts what the user typed and returns the value
          *               and text to display in the select box
          */
         init: function (list, options) {
            return this.each(function () {
               var jBaseElement = $(this),
                  data = jBaseElement.data('c21minmaxdropdown');

               // If the plugin hasn't been initialized yet
               if (!data) {
                  data = {};

                  if (!options) {
                     options = list;
                     list = undefined;
                     //list = getList(jBaseElement);
                  }

                  var baseName = options.baseName.toLowerCase();
                  var jDropdownHeaderContainer = $('<div />', {
                        html: [
                           '<div class="dropdownHeaderStart">',
                           '<label class="sr-only" for="foregroundInput-' + baseName + '">Min</label>',
                           '<input type="text" class="foreground" id="foregroundInput-' + baseName + '"/>',
                           '</div>',
                           '<div class="dropdownTo">to</div>',
                           '<div class="dropdownHeaderEnd">',
                           '<label class="sr-only" for="foregroundInput2-' + baseName + '">Max</label>',
                           '<input type="text" class="foreground" id="foregroundInput2-' + baseName + '" />',
                           '</div>'
                        ].join(''),
                        "class": 'dropdownHeaderContainer'
                     }),

                     t = (options.translate) ? options.translate : function (s) { return s; },

                     /**
                      * Not using the jQuery uniform library because uniform uses a REAL select box.
                      * Real select boxes can not have the click event cancelled in webkit browsers.
                      * Instead, we are piggybacking on the uniform CSS
                      */
                     jMinMaxBox = $([
                        '<div class="selector smallSelector">',
                        '<span></span>',
                        '<input type="hidden" id="', options.baseName, 'From" name="', options.baseName, 'From" value="" />',
                        '<input type="hidden" id="', options.baseName, 'To" name="', options.baseName, 'To" value="" />',
                        '</div>'
                     ].join('')),
                     jMinInput = jMinMaxBox.find('input').eq(0),
                     jMaxInput = jMinMaxBox.find('input').eq(1),
                     jStartForeground = jDropdownHeaderContainer.find('.dropdownHeaderStart input.foreground'),
                     jEndForeground = jDropdownHeaderContainer.find('.dropdownHeaderEnd input.foreground'),

                     m_bValueChanged = false,
                     m_bFirstClick = true,

                     setValue = function (strText, strMinValue, strMaxValue) {
                        jMinMaxBox.find('span').text(t(strText));

                        var strMinOld = jMinInput.val(),
                           strMaxOld = jMaxInput.val();

                        if ((strMinOld !== strMinValue) || (strMaxOld !== strMaxValue)) {
                           m_bValueChanged = true;
                        }

                        jMinInput.val(strMinValue);
                        jMaxInput.val(strMaxValue);
                     },

                     resetBoxes = function () {
                        jStartForeground.val('');
                        jEndForeground.val('');
                     },

                     getDisplay = function (jOption) {
                        var strSelectedDisplay = jOption.attr('selectedDisplay'),
                           strText = jOption.text(),
                           strDisplay = strSelectedDisplay || strText;

                        return strDisplay;
                     },

                     /**
                      * Formats the results into one of the following:
                      * '#+', '# - #', 'Any'
                      */
                     defaultFormatter = function (strMin, strMax) {
                        var iMinVal = parseInt(strMin.replace(/[^0-9.]/gi, ''), 10),
                           iMaxVal = parseInt(strMax.replace(/[^0-9.]/gi, ''), 10);

                        if (isNaN(iMinVal)) {
                           iMinVal = 0;
                        }

                        if (isNaN(iMaxVal)) {
                           iMaxVal = 0;
                        }

                        if ((iMaxVal !== 0) && (iMaxVal < iMinVal)) {
                           var iTmp = iMaxVal;
                           iMaxVal = iMinVal;
                           iMinVal = iTmp;
                        }

                        if (iMinVal === 0) {
                           if (iMaxVal === 0) {
                              return {
                                 text: options.textHint || "Any",
                                 minValue: '',
                                 maxValue: ''
                              };
                           } else {
                              return {
                                 text: '0 - ' + iMaxVal.toString(),
                                 minValue: '0',
                                 maxValue: iMaxVal.toString()
                              };
                           }
                        } else {
                           if (iMaxVal === 0) {
                              return {
                                 text: iMinVal.toString() + '+',
                                 minValue: iMinVal.toString(),
                                 maxValue: ''
                              };
                           } else if (iMaxVal === iMinVal) {
                              return {
                                 text: iMinVal.toString(),
                                 minValue: iMinVal.toString(),
                                 maxValue: iMaxVal.toString()
                              };
                           } else {
                              return {
                                 text: iMinVal.toString() + ' - ' + iMaxVal.toString(),
                                 minValue: iMinVal.toString(),
                                 maxValue: iMaxVal.toString()
                              };
                           }
                        }
                     },

                     doFormat = function (strMin, strMax) {
                        var formatter = defaultFormatter;

                        if (options.formatter) {
                           formatter = options.formatter;
                        }

                        var formatterResult = formatter(strMin, strMax);

                        setValue(
                           formatterResult.text,
                           formatterResult.minValue,
                           formatterResult.maxValue
                        );
                     },

                     callFormatter = function () {
                        var strMin = jStartForeground.val(),
                           strMax = jEndForeground.val();

                        if (strMin !== '' || strMax !== '') {
                           jBaseElement.c21dropdown("addHeaderHighlight");
                        } else {
                           jBaseElement.c21dropdown("removeHeaderHighlight");
                        }

                        doFormat(strMin, strMax);
                     },

                     setupText = function (jForeground, strPlaceholder) {
                        jForeground
                           .attr("placeholder", strPlaceholder)
                           .keyup(function (event) {
                              var strValue = jStartForeground.val(),
                                 iKeyCode = event.keyCode;

                              switch (iKeyCode) {
                              case 13: // ENTER key
                              case 32: // SPACE bar
                              case 38: // UP arrow
                              case 40: // DOWN arrow
                                 return;
                              }

                              callFormatter();

                              var strNewValue = strValue.replace(/[^0-9]/g, '');
                              if (strNewValue !== strValue) {
                                 jForeground.val(strNewValue);
                              }
                           });
                     },

                     refreshValue = function (bOptionTriggered) {
                        var strText = jBaseElement.c21dropdown("getSelectedText"),
                           strValue = jBaseElement.c21dropdown("getSelectedValue"),
                           aValues;
                           
                        if (strValue) {
                           aValues = strValue.split("-");
                           if (aValues.length === 2) {
                              // EX: ["0", "1"]
                              setValue(strText, aValues[0], aValues[1]);
                           } else {
                              // EX: ["2000"]
                              setValue(strText, strValue, '');
                           }
                        } else if ((strValue === undefined) && bOptionTriggered) {
                           // User entered something manually?
                        } else {
                           setValue(strText, strValue, '');
                        }
                     },

                     onOptionTriggered = function () {
                        refreshValue(true);
                        resetBoxes();

                        jBaseElement.c21dropdown("hideDropdown");
                        jStartForeground.get(0).blur();
                        jEndForeground.get(0).blur();
                     },

                     onFocus = function () {
                        $(document).trigger('hideDropdowns');
                        jBaseElement.c21dropdown("showAndRepositionDropdown");
                        if (m_bFirstClick) {
                           m_bFirstClick = false;
                        }
                     },

                     setInitialValue = function () {
                        var oElementData = jBaseElement.data(),
                           strMin = oElementData.min || "",
                           strMax = oElementData.max || "",
                           strSelected = oElementData.selected;

                        if (strMin || strMax) {
                           doFormat(strMin.toString(), strMax.toString());
                        } else if (strSelected) {
                           jBaseElement.val(strSelected);
                        }
                     },

                     initialize = function () {
                        var strRandomId,
                           strDropdownClass = options.dropdownClass || "";

                        jBaseElement.c21dropdown(list, {
                           headerContent: jDropdownHeaderContainer,
                           dropdownClass: strDropdownClass + " c21minmaxdropdown",
                           appearUnderText: true,
                           translate: t,
                           onBlur: function () {
                              if (m_bValueChanged) {
                                 m_bValueChanged = false;
                                 if (options.onBlurAndChange) {
                                    options.onBlurAndChange(jBaseElement.val());
                                 }
                              }

                              // NOTE: Fires after onBlurAndChange
                              if (options.onBlur) {
                                 options.onBlur(jBaseElement.val());
                              }
                           },
                           hoverElement: jBaseElement,
                           relativeTo: jMinMaxBox,
                           onTrigger: onOptionTriggered,
                           listOptions: {
                              onOptionTriggered: onOptionTriggered
                           }
                        });

                        strRandomId = jBaseElement.c21dropdown("getRandomId");
                        jMinInput.addClass(strRandomId + "_input");

                        if (options.selectBoxClass) {
                           jMinMaxBox.addClass(options.selectBoxClass);
                        }

                        if (options.maxLength) {
                           jStartForeground.attr('maxlength', options.maxLength.toString());
                           jEndForeground.attr('maxlength', options.maxLength.toString());
                        }

                        if (options.tabIndex) {
                           jStartForeground.attr('tabindex', options.tabIndex);
                           jEndForeground.attr('tabindex', options.tabIndex + 1);
                        }

                        setupText(jStartForeground, t("Min"));
                        setupText(jEndForeground, t("Max"));

                        jStartForeground.focus(onFocus);
                        jEndForeground.focus(onFocus);

                        jMinMaxBox.on("click", function (e) {
                           $(document).trigger('hideDropdowns');
                           jBaseElement.c21dropdown("toggle");

                           if (m_bFirstClick) {
                              m_bFirstClick = false;
                           }
                        });

                        $.extend(data, {
                           target: jBaseElement,
                           doFormat: doFormat
                        });

                        jBaseElement
                           .after(jMinMaxBox).hide()
                           .data("c21minmaxdropdown", data);

                        refreshValue();
                        setInitialValue();
                     };

                  initialize();
               }
            });
         },

         /**
          * Determine whether this element is hidden
          */
         hidden: function () {
            return $(this).c21dropdown("hidden");
         },

         setValue: function (strMin, strMax) {
            var jBaseElement = $(this),
               data = jBaseElement.data("c21minmaxdropdown");

            data.doFormat(strMin, strMax);
         },

         destroy: function () {
            return this.each(function () {
               var jBaseElement = $(this),
                  data = jBaseElement.data("c21minmaxdropdown");

               jBaseElement.c21dropdown("destroy");
               data.c21minmaxdropdown.remove();
               jBaseElement.removeData("c21minmaxdropdown");
            });
         }
      };

   $.fn.c21minmaxdropdown = function (method) {
      if (!this.length) return this; // If there are no objects selected, we don't need to have a dropdown box.
      if (methods[method]) {
         return methods[method].apply(this, Array.prototype.slice.call(arguments, 1));
      } else if (typeof method === 'object' || !method) {
         return methods.init.apply(this, arguments);
      } else {
         $.error('Method ' + method + ' does not exist on jQuery.c21minmaxdropdown');
      }
   };
}(jQuery));
